export default __webpack_public_path__ + "static/media/030-sanctuary of our lady of lourdes.176ebc7c.svg";